import { Link } from "react-router-dom";
import { EVENTS } from "@/mocks/events";
import SectionHeading from "./SectionHeading";

export default function HotRank() {
  const top = [...EVENTS].sort((a, b) => b.heat - a.heat);
  const featured = top[0];
  const rest = top.slice(1, 6);
  const maxHeat = top[0].heat;

  return (
    <section id="hot" className="mx-auto w-full scroll-mt-24 max-w-7xl px-4 py-14 md:px-6 md:py-20" aria-label="今日热榜">
      <SectionHeading
        icon="ri-fire-line"
        kicker="今日热榜"
        title="此刻全网都在吃的瓜"
        desc="按热度实时排序，热度来自阅读量、讨论量与转发量的综合指数。点击任意事件即可进入完整时间线。"
      />

      <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-5">
        {/* 榜首大卡 */}
        <Link
          to={`/story/${featured.id}`}
          className="group relative flex flex-col overflow-hidden rounded-3xl bg-background-100 lg:col-span-3"
        >
          <div className="relative aspect-[16/10] w-full overflow-hidden">
            <img
              src={featured.cover}
              alt={featured.title}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
              <i className="ri-fire-fill" aria-hidden="true"></i>
              热度 {featured.heat}
            </span>
          </div>
          <div className="flex flex-1 flex-col p-5 md:p-6">
            <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
              <i className="ri-medal-2-line" aria-hidden="true"></i>
              榜首事件
            </span>
            <h3 className="mt-3 text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-2xl">
              {featured.title}
            </h3>
            <p className="mt-2.5 line-clamp-3 text-sm leading-relaxed text-foreground-600">
              {featured.excerpt}
            </p>
            <div className="mt-auto flex items-center gap-4 pt-4 text-xs text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-eye-line" aria-hidden="true"></i>
                {featured.views} 阅读
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-chat-3-line" aria-hidden="true"></i>
                {featured.comments} 讨论
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line" aria-hidden="true"></i>
                阅读约 {featured.readingMin} 分钟
              </span>
            </div>
          </div>
        </Link>

        {/* 榜单列表 */}
        <div className="flex flex-col gap-3 lg:col-span-2">
          {rest.map((item, index) => {
            const rank = index + 2;
            return (
              <Link
                key={item.id}
                to={`/story/${item.id}`}
                className="group flex items-center gap-4 rounded-2xl bg-background-100 p-3 transition-colors hover:bg-primary-100/60"
              >
                <span
                  className={`flex h-10 w-9 shrink-0 items-center justify-center rounded-xl font-display text-lg ${
                    rank <= 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-secondary-200 text-secondary-800"
                  }`}
                >
                  {rank}
                </span>
                <div className="min-w-0 flex-1">
                  <span className="text-[11px] font-semibold text-primary-600">
                    {item.category} · {item.tag}
                  </span>
                  <h4 className="mt-0.5 line-clamp-2 text-sm font-semibold leading-snug text-foreground-900 group-hover:text-primary-700">
                    {item.hotTitle}
                  </h4>
                  <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-primary-400 to-primary-500"
                      style={{ width: `${(item.heat / maxHeat) * 100}%` }}
                    ></div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}